import { render, staticRenderFns } from "./PersonProfileMasterRecord.vue?vue&type=template&id=75bac0cd&scoped=true&"
import script from "./PersonProfileMasterRecord.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterRecord.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileMasterRecord.vue?vue&type=style&index=0&id=75bac0cd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bac0cd",
  null
  
)

export default component.exports